function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 32" {...props}><path d="M11.429 10.571q0 1.429-1 2.429T8 14t-2.429-1-1-2.429 1-2.429 2.429-1 2.429 1 1 2.429m18.285 6.858v8H4.574V22l5.714-5.714 2.857 2.857L22.288 10zm1.715-12.572H2.858q-.232 0-.402.17t-.17.402v21.714q0 .232.17.402t.402.17h28.571q.232 0 .402-.17t.17-.402V5.429q0-.232-.17-.402t-.402-.17m2.857.572v21.714q0 1.179-.839 2.02t-2.02.839H2.856q-1.179 0-2.02-.839t-.839-2.02V5.429q0-1.179.839-2.02t2.02-.839h28.571q1.179 0 2.02.839t.839 2.02" /></svg>;
});